<template>
  <div>
    <table>
      <tr>
        <th>Name</th>
        <th>Logo</th>
        <th>Details</th>
      </tr>
      <providerRow
        v-for="(provider, index) in providers"
        tag="tr"
        :key="index"
        :provider="provider"
        :type="type"
      />
    </table>

    <div class="container" style="width: 100%;">
      <div class="row">
        <div style="float: left">
          <button
            class="nav-button"
            style="border-width: 1px;"
            v-on:click="$store.commit('prevPage', 1)"
            v-if="!isFirstPage"
          >
            <span>&#x2190; Prev</span>
          </button>
        </div>

        <div style="float: right">
          <button
            class="nav-button"
            style="border-width: 1px;"
            v-on:click="$store.commit('nextPage', 1)"
            v-if="!isLastPage"
          >
            <span>Next &#x2192;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import providerRow from "./providerRow.vue";

export default {
  name: "display-and-select-page",
  props: ["providers", "title", "type"],
  components: {
    providerRow: providerRow
  },
  computed: {
    ...mapGetters(["isLastPage", "isFirstPage"])
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  background-color: white;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #eaeaea;
}

.container {
  border-style: hidden;
}

.bottom-container {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  color: white;
  text-align: center;
}

.nav-button {
  display: inline-block;
  padding: 5px 15px 5px 15px;
  margin-left: 13px;
  margin-right: 13px;
  border: solid 1px white;
  font-size: 16px;
  border-radius: 5px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  /* background-color:#2d3f4f; */
  /* color: white; */
}

.nav-button:hover {
  color: #32a6ae;
}
</style>



// WEBPACK FOOTER //
// src/elements/displayAndSelect.vue